import { parse, stringify } from 'qs';
import { IConfig } from '@cian/config/shared';

export const goToAuthentication = (config: IConfig) => {
  const authUrl = config.getStrict<string>('request-form-realtor-frontend.authBaseUrl');
  const rawMcsUrl = config.get<string>('request-form-realtor-frontend.baseUrl') || '';

  const queryParams = window.location.search
    ? `${stringify({ ...parse(window.location.search, { ignoreQueryPrefix: true }), authenticated: true }, { addQueryPrefix: true })}`
    : '?authenticated=true';

  const mcsUrl = encodeURIComponent(`${rawMcsUrl}${queryParams}`);

  window.location.href = `${authUrl}?headingType=selectRealtor&back_url=${mcsUrl}`;

  return undefined;
};
